import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import {
  defaultReservationCandidateListSearchConditionItem,
  ReservationCandidateListSearchConditionItem,
  ReservationCandidateListSearchTableItem
} from '@/components/templates/reservation-candidate-list'
import { cloneDeep } from 'lodash'

@Module({
  name: 'ReservationCandidateListStore',
  namespaced: true,
  stateFactory: true
})
export default class ReservationCandidateListStore extends BaseStore {
  // 検索画面で検索したかどうかの判定
  _isSearched: boolean = false

  // 検索条件、登録画面で入力値などを表示する際に使用する
  _searchCondition: ReservationCandidateListSearchConditionItem = defaultReservationCandidateListSearchConditionItem()

  // 検索した条件、更新、登録、削除後、同検索条件で最新の情報を取得する際に使用する
  _searchedCondition: ReservationCandidateListSearchConditionItem = defaultReservationCandidateListSearchConditionItem()

  // 照会画面から戻ってきた時に表示する検索結果一覧
  // 照会画面で更新、登録、削除等を行うので、処理後、最新の値を検索結果に反映する為に準備
  _searchResults: ReservationCandidateListSearchTableItem[] = []

  get isSearched(): boolean {
    return this._isSearched
  }

  get searchCondition(): ReservationCandidateListSearchConditionItem {
    return this._searchCondition
  }

  get searchedCondition(): ReservationCandidateListSearchConditionItem {
    return this._searchedCondition
  }

  get searchResults(): ReservationCandidateListSearchTableItem[] {
    return this._searchResults
  }

  @Mutation
  public setIsSearched(value: boolean) {
    this._isSearched = value
  }

  @Mutation
  public setSearchCondition(
    value: ReservationCandidateListSearchConditionItem
  ) {
    this._searchCondition = value
  }

  @Mutation
  public setSearchedCondition(
    value: ReservationCandidateListSearchConditionItem
  ) {
    this._searchedCondition = value
  }

  // バグの元にならないように設定時点で参照を破棄する
  @Mutation
  public setSearchResults(value: ReservationCandidateListSearchTableItem[]) {
    this._searchResults = cloneDeep(value)
  }

  @Mutation
  public reset() {
    this._isSearched = false
    this._searchCondition = defaultReservationCandidateListSearchConditionItem()
    this._searchedCondition = defaultReservationCandidateListSearchConditionItem()
    this._searchResults = []
  }
}
